export default __webpack_public_path__ + "static/media/Appropriate_small.7d044ac8.svg";